import * as React from 'react';

import {TruncatedElement} from '../../../truncated/truncated-element';

import styles from './truncated-timeline-entry-content.module.css';

// Will display 6 lines of content
export const MAX_ELEMENT_HEIGHT = 100;

type Props = {
    content: string | React.ReactNode | null | undefined;
};

export function TruncatedTimelineEntryContent(props: Props) {
    const {content} = props;

    return content ? (
        <div className={styles['truncated-content-container']}>
            {typeof content === 'string' ? (
                <div className={styles['truncated-content']}>{content}</div>
            ) : (
                <TruncatedElement content={content} maxHeight={MAX_ELEMENT_HEIGHT} />
            )}
        </div>
    ) : null;
}
